const menuItems = [
  { id: 'overview', icon: 'ri-dashboard-line', label: 'Overview' },
  { id: 'site-settings', icon: 'ri-settings-3-line', label: 'Site Settings' },
  { id: 'about', icon: 'ri-user-group', label: 'About Us' },
  { id: 'contact-info', icon: 'ri-telephone', label: 'Contact Info' },
  { id: 'hero', icon: 'ri-image-line', label: 'Hero Section' },
  { id: 'stories', icon: 'ri-book-open-line', label: 'Impact Stories' },
  { id: 'testimonials', icon: 'ri-chat-quote-line', label: 'Testimonials' },
  // { id: 'team', icon: 'ri-team-line', label: 'Team Members' },
  { id: 'donation', icon: 'ri-team-line', label: 'Donations' },
  { id: 'volunteer-application', icon: 'ri-team-line', label: 'Volunteer Application' },
  { id: 'contact-message', icon: 'ri-team-line', label: 'Contact Message' },
  { id: 'statistics', icon: 'ri-bar-chart-line', label: 'Statistics' },
  { id: 'volunteer', icon: 'ri-hand-heart-line', label: 'Volunteer Opportunities' },
  { id: 'pages', icon: 'ri-pages-line', label: 'Pages' },
];

export default function Sidebar({ activeSection, onSectionChange, isMobileOpen, onMobileClose }) {
  return (
    <>
      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={onMobileClose}
        />
      )}
      
      {/* Sidebar */}
      <aside className={`fixed top-0 left-0 h-full w-64 bg-white border-r border-gray-200 z-50 transform transition-transform duration-300 lg:translate-x-0 ${isMobileOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-[#6a4bc3] rounded-lg flex items-center justify-center">
                <i className="ri-dashboard-3-line text-white text-xl"></i>
              </div>
              <div>
                <h1 className="font-bold text-gray-900 text-sm">Dashboard</h1>
                <p className="text-xs text-gray-500">Content Manager</p>
              </div>
            </div>
            <button 
              onClick={onMobileClose}
              className="lg:hidden w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-700 cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
        </div>
        
        <nav className="p-4 space-y-1 overflow-y-auto h-[calc(100%-88px)]">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                onSectionChange(item.id);
                onMobileClose();
              }}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all cursor-pointer ${
                activeSection === item.id
                  ? 'bg-[#6a4bc3] text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <i className={`${item.icon} text-lg`}></i>
              <span>{item.label}</span>
            </button>
          ))}
          
          <div className="pt-4 mt-4 border-t border-gray-200">
            <a
              href="/"
              target="_blank"
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-all cursor-pointer"
            >
              <i className="ri-external-link-line text-lg"></i>
              <span>View Website</span>
            </a>
          </div>
        </nav>
      </aside>
    </>
  );
}
